import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import { NextUIProvider } from '@nextui-org/react'
import * as Sentry from '@sentry/react'
import LogRocket from 'logrocket'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './i18n/config'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { bindStoresToWindow } from './utils/storeDebug'

const isLocalOrDev = import.meta.env.MODE === 'development' || import.meta.env.MODE === 'local'

// Microsoft Clarity
const clarityId = import.meta.env.VITE_CLARITY_PROJECT_ID
if (clarityId) {
  ;(function (c: any, l: Document, a: string, r: string, i: string) {
    c[a] =
      c[a] ||
      function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }
    const t = l.createElement(r) as HTMLScriptElement
    t.async = true
    t.src = 'https://www.clarity.ms/tag/' + i
    const y = l.getElementsByTagName(r)[0]
    y.parentNode!.insertBefore(t, y)
  })(window, document, 'clarity', 'script', clarityId)
}

// LogRocket
if (import.meta.env.VITE_LOGROCKET_APP_ID) {
  LogRocket.init(import.meta.env.VITE_LOGROCKET_APP_ID)
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
  ],
  replaysSessionSampleRate: isLocalOrDev ? 0.05 : 1.0,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

// 개발 환경에서 zustand store들을 window에 바인딩
bindStoresToWindow()

const theme = extendTheme({
  fonts: {
    heading: 'Noto Sans',
    body: 'Noto Sans',
    html: 'Noto Sans',
    mono: 'Noto Sans',
  },
})
root.render(
  <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
    <ChakraProvider theme={theme}>
      <NextUIProvider locale="en-CA">
        {/*<ChakraProvider>*/}
        <App />
      </NextUIProvider>
    </ChakraProvider>
  </BrowserRouter>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
